module.exports = __webpack_public_path__ + "assets/img/bg.7da9ea42.png";